export const Slider = () => {
  const swiperWrapper = document.querySelectorAll(".swiper");
  if (swiperWrapper) {
    swiperWrapper.forEach((s) => {
      console.log("s", s);
      const prev = s.parentNode.querySelector(".slider-navigation .prev");
      const next = s.parentNode.querySelector(".slider-navigation .next");
      if (prev) {
        prev.addEventListener("click", () => {
          sw.slidePrev();
        });
      }
      if (prev) {
        next.addEventListener("click", () => {
          sw.slideNext();
        });
      }

      const test = new Swiper(s, {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  if (innerWidth > 900) {
    Slider();
  }
});
